import { Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import * as glob from '../../../../shared/global';
import {MasterService} from '../../master.service';
import './../../../../../assets/js/index';
import {setToggleBar, toggleBar} from '../../../../../assets/js';
import {PlatformLocation} from '@angular/common';


@Component({
    selector: 'app-master',
    templateUrl: './master.component.html',
    styleUrls: ['./master.component.css'],

})
export class MasterComponent implements OnInit, OnDestroy {
    public permission: string = '';
    public _subcCription: Subscription;
    public time: number;

    constructor(
        private _masterService: MasterService,
        location: PlatformLocation
    ) {
        location.onPopState(() => {
            setToggleBar();
        });
    }

    ngOnInit() {
        toggleBar();
        this._subcCription = this._masterService.refreshToken().subscribe(res => {
            const dt = res.body.data.permission;
            this.permission = dt;
        });
        const that = this;
        this.time = setInterval(function () {
            that._masterService.refreshToken().subscribe(data => {
            });
        }, glob.TIME_REFRESH_TOKEN);
    }

    ngOnDestroy() {

        clearInterval(this.time);
        if (this._subcCription) {
            this._subcCription.unsubscribe();
        }
    }

}
